$( document ).ready(function() {
    // A classname, amely alatt a címsorokat szeretnénk kiírni
    const classname = "title-type";

    // A karakterek kiírásának sebessége (ms-ban)
    const speed = 75;

    // Az adott classnévvel rendelkező szekciók kiválasztása
    const sections =  document.querySelectorAll("." + classname);

    // A címsorok megjelenítése, ha a felhasználó a megfelelő szekcióhoz ér
    const showSection = (section) => {
        const sectionTop = section.offsetTop;
        const scrollPosition = window.pageYOffset + window.innerHeight;
        const sectionBottom = sectionTop + section.offsetHeight;
        if (scrollPosition >= sectionTop + 200 ) {
            const titles = section.querySelectorAll("h1 span, h2 span");
            titles.forEach((title) => {
                if (!title.classList.contains("printed")) {
                    title.classList.add("printed");
                    typeWriter(title);
                }
            });
        }
    };

    // Az adott classnévvel rendelkező szekciókban található címsorok megjelenítése,
    // ha a felhasználó a megfelelő szekcióhoz ér
    const checkSections = () => {
        sections.forEach((section) => {
            showSection(section);
        });
    };

    // Az oldal betöltésekor is ellenőrizzük a címsorokat
    // if (document.readyState === "complete")
        checkSections();
    // window.addEventListener('load', () => {
    //     checkSections();
    // });

    // Az adott classnévvel rendelkező szekciókban található címsorok megjelenítése, ha a felhasználó a megfelelő szekcióhoz görget
    window.addEventListener("scroll", () => {
        checkSections();
    });

    function typeWriter(el) {
        const textArray = el.innerHTML.split('');
        el.style.display = 'inline';
        el.innerHTML = '';
        textArray.forEach((letter, i) =>
            setTimeout(() => (el.innerHTML += letter), speed * i)
        );
    }
});
